import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  0%, 20%, 40%, 60%, 80%, 100% {\n    transform: rotate(-3deg);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    transform: rotate(3deg);\n  }\n'], ['\n  0%, 20%, 40%, 60%, 80%, 100% {\n    transform: rotate(-3deg);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    transform: rotate(3deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  opacity: ', ';\n  background-color: ', '\n  position: relative;\n  border-radius: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ', 'px;\n  height: ', 'px;\n  ', '\n  ', '\n  ', '\n'], ['\n  opacity: ', ';\n  background-color: ', '\n  position: relative;\n  border-radius: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ', 'px;\n  height: ', 'px;\n  ', '\n  ', '\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    ', '\n\n    ', '\n\n    ', '\n  '], ['\n    ', '\n\n    ', '\n\n    ', '\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        border: ', ';\n      '], ['\n        border: ', ';\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        border: 2px solid ', ';\n      '], ['\n        border: 2px solid ', ';\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n        border: 0px solid transparent;\n      '], ['\n        border: 0px solid transparent;\n      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      animation: ', ' 0.82s linear infinite;\n      backface-visibility: hidden;\n      perspective: 1000px;\n    '], ['\n      animation: ', ' 0.82s linear infinite;\n      backface-visibility: hidden;\n      perspective: 1000px;\n    ']);

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { styles } from 'gipsy-misc';
import Icon from '../Icon';

var DefaultPicture = function (_Component) {
  _inherits(DefaultPicture, _Component);

  function DefaultPicture() {
    _classCallCheck(this, DefaultPicture);

    return _possibleConstructorReturn(this, (DefaultPicture.__proto__ || Object.getPrototypeOf(DefaultPicture)).apply(this, arguments));
  }

  _createClass(DefaultPicture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          backgroundColor = _props.backgroundColor,
          iconColor = _props.iconColor,
          showIcon = _props.showIcon,
          borderRadius = _props.borderRadius,
          active = _props.active,
          border = _props.border,
          shake = _props.shake,
          opacity = _props.opacity;


      return React.createElement(
        Container,
        {
          className: 'default-picture',
          border: border,
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          active: active,
          size: size,
          shake: shake,
          opacity: opacity },
        this.props.children,
        showIcon && React.createElement(Icon, { icon: 'User', size: backgroundColor !== 'transparent' ? size / 2 : size, fill: iconColor })
      );
    }
  }]);

  return DefaultPicture;
}(Component);

DefaultPicture.propTypes = {
  children: PropTypes.any,
  iconColor: PropTypes.string.isRequired,
  showIcon: PropTypes.bool.isRequired,
  borderRadius: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  active: PropTypes.bool,
  border: PropTypes.string,
  size: PropTypes.number.isRequired,
  opacity: PropTypes.number
};
DefaultPicture.defaultProps = {
  size: 32,
  showIcon: true,
  borderRadius: '50%',
  iconColor: styles.colors.darkGrey,
  backgroundColor: styles.colors.backgroundGreyColor,
  opacity: 1
};


export default DefaultPicture;

var shakeAnimation = keyframes(_templateObject);

var Container = styled.div(_templateObject2, function (props) {
  return props.opacity;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderRadius;
}, function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var border = _ref3.border,
      active = _ref3.active;
  return css(_templateObject3, border && css(_templateObject4, border), !border && active && css(_templateObject5, styles.colors.primaryColor), !border && !active && css(_templateObject6));
}, function (_ref4) {
  var additionnalCss = _ref4.additionnalCss;
  return additionnalCss;
}, function (_ref5) {
  var shake = _ref5.shake;
  return shake && css(_templateObject7, shakeAnimation);
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DefaultPicture/index.js
// module id = 823
// module chunks = 0